<template>
    <v-dialog v-model="editDialog.status" width="1000">
      <v-card>
        <v-card-title>
          Edit {{editDialog.type}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="editDialog.type === 'Client'">
            <v-row>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.MemberGTLCode" type="number" label="MemberGTLCode" placeholder="30001027" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.FamilyGTLCode" type="number" label="FamilyGTLCode" placeholder="60001044" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.AgentGTLCode" type="number" label="AgentGTLCode" placeholder="20001008" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.MemberEmailID" label="MemberEmailID" placeholder="1234567890@qq.com" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.MemberWIXID" label="MemberWIXID" placeholder="99342247-5e8d-4acd-8f1f-22bfdb4736d7" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.display_name" label="Display Name" placeholder="陳大文" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.first_name" label="First Name" placeholder="陳" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.last_name" label="Last Name" placeholder="大文" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.contact_email" label="Email" placeholder="chantaiman@gmail.com" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.mobile_number" label="Mobile Number" placeholder="+86 14216584753" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.wechatID" label="WechatID" placeholder="chantaiman13" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-select v-model="editDialog.client.gender" :items="['M','F']" label="Gender" placeholder="M" outlined></v-select>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.dob" label="DOB" placeholder="1982-12-03" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.weight" type="number" label="Weight" placeholder="52.3" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.nationality" label="Nationality" placeholder="中國大陸" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.race" label="Race" placeholder="東亞人" outlined></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field v-model="editDialog.client.address" label="Address" placeholder="香港尖沙咀北京道1號12樓" outlined></v-text-field>
              </v-col>
              <v-col md="4" offset-md="4">
                <v-text-field v-model="editDialog.client.display_lang" label="Display Language" placeholder="簡體中文" outlined></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn outlined color="primary" @click="submit_update">Submit</v-btn>
          <v-btn outlined color="grey" @click="editDialog.status = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'index',
  data: () => ({
    editDialog: {}
  }),
  created () {
    this.editDialog = this.$store.state.editDialog
  },
  methods: {
    submit_update () {
      if (this.editDialog.type === 'Client') {
        this.$store.commit('setLoadingState', true)
        this.$apis.updateAdditionalInformation(this.editDialog.client).then(res => {
          if (res.data.status === true) {
            this.$store.commit('setSnackBar', {
              status: true,
              color: 'success',
              icon: 'far fa-check-square',
              message: 'Client Updated'
            })
            this.editDialog.status = false
            this.$store.commit('setLoadingState', false)
          } else {
            this.$store.commit('setSnackBar', {
              status: false,
              color: 'error',
              icon: 'fas fa-exclamation-triangle',
              message: 'Error: Client update fail'
            })
            this.editDialog.status = false
            this.$store.commit('setLoadingState', false)
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
